import { createExperimentHook } from 'src/components/experiment';

export const useKWLPLimitProducts = createExperimentHook(
  'kwlp-limit-products',
  100,
  {
    items24: 24,
    items48: 48,
  }
);
export const useStrictSearch = createExperimentHook('strict-search', false, {
  strict: true,
});

export const useKWLPDeprioritizeNoImageOffers = createExperimentHook(
  'kwlp-deprioritize-no-image-offers',
  false,
  {
    deprioritize: true,
  }
);

export const useShowAllVariantsExperiment = createExperimentHook(
  'show-all-variants',
  false,
  {
    show: true,
  }
);

export const useNewPriceHistoryExperiment = createExperimentHook(
  'price-history-new',
  false,
  {
    new: true,
  }
);

export const useNewCampaignCardExperiment = createExperimentHook(
  'campaign-product-card',
  false,
  {
    new: true,
  }
);

export const useWideCategoryTableExperiment = createExperimentHook(
  'wide-category-table',
  false,
  {
    wide: true,
  }
);

export const useProductRelationsExperiment = createExperimentHook(
  'product-relations',
  false,
  {
    show: true,
  }
);
